import React from "react";
import { motion } from "framer-motion";

const AI_AVATAR =
  "https://static.prod-images.emergentagent.com/jobs/b9a6f8ac-ae9e-4cbf-9b6d-e590a64b44ee/images/6c99ee1aa365db3f6f9a5be21aaf930265acd3722b4b50b28b7389055d758d68.png";

const MOOD_LABELS = {
  challenge_beat: "Te superaron",
  daily_won: "Ganaste hoy",
  daily_almost: "Casi casi",
  daily_lost: "Hoy no alcanzó",
  streak_risk: "Racha en riesgo",
  streak_proud: "Racha activa",
  daily_pending: "Reto pendiente",
  newcomer: "Primera vez",
  guest_first: "Sé el primero",
  guest_hard: "Difícil hoy",
  guest_social: "Reto del día",
  default: "REBECA dice",
  guest_default: "REBECA dice",
};

export default function RebecaHomeCard({
  message,
  ctaHint,
  mood = "default",
  compact = false,
  children,
  testId = "rebeca-home-card",
}) {
  const moodLabel = MOOD_LABELS[mood] || MOOD_LABELS.default;

  return (
    <motion.div
      initial={{ scale: compact ? 0.98 : 0.92, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ duration: 0.4 }}
      className="bg-[#101010] border-4 border-[#101010] rounded-xl cm-shadow overflow-hidden mb-5"
      data-testid={testId}
    >
      <div className="bg-[#FF4C4C] px-4 py-2 flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <span className="font-mono-cm text-[11px] uppercase tracking-widest text-white font-bold">REBECA</span>
          <span className="font-mono-cm text-[11px] text-white/60 uppercase tracking-widest">· oponente IA</span>
        </div>
        <span className="font-mono-cm text-[9px] uppercase tracking-widest text-white/80 bg-white/10 px-2 py-0.5 rounded">
          {moodLabel}
        </span>
      </div>

      <div className={`flex items-start gap-4 ${compact ? "p-4" : "p-5 md:p-7"}`}>
        <motion.img
          src={AI_AVATAR}
          alt="REBECA"
          animate={{ y: [0, -5, 0] }}
          transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
          className={`object-contain shrink-0 drop-shadow-[4px_4px_0px_rgba(255,76,76,0.6)] ${
            compact ? "w-14 h-14 md:w-16 md:h-16" : "w-20 h-20 md:w-24 md:h-24"
          }`}
        />
        <div className="flex-1 min-w-0">
          <p
            className={`text-white font-display uppercase leading-tight mb-2 ${
              compact ? "text-lg md:text-xl" : "text-xl md:text-2xl"
            }`}
            data-testid="rebeca-home-message"
          >
            &ldquo;{message}&rdquo;
          </p>
          {ctaHint && (
            <p className="font-mono-cm text-[10px] uppercase tracking-widest text-[#FFDE59]/90">
              {ctaHint}
            </p>
          )}
          {children}
        </div>
      </div>
    </motion.div>
  );
}
